import { useEffect, useState } from "react";

import { apiGet } from "../../../../Api/Client.js";

// The tax rules and commission plans a pay profile can point to. Fetched only for a company that has the add-on.
export function useFormulaLookups(on) {
  const [lookups, setLookups] = useState({ taxRules: [], plans: [] });
  useEffect(() => {
    if (!on) return undefined;
    let current = true;
    Promise.all([apiGet("/FinanceAndPayroll/pay-tax-rules/"), apiGet("/FinanceAndPayroll/pay-commission-plans/")])
      .then(([rules, plans]) => { if (current) setLookups({ taxRules: rules?.rules || [], plans: plans?.plans || [] }); })
      .catch(() => { if (current) setLookups({ taxRules: [], plans: [] }); });
    return () => { current = false; };
  }, [on]);
  return lookups;
}
